export interface City {
  name: string;
  state: string;
}

export const CITIES: City[] = [
  { name: "Mumbai", state: "Maharashtra" },
  { name: "Surat", state: "Gujarat" },
  { name: "Goa", state: "Goa" },
  { name: "Mangalore", state: "Karnataka" },
  { name: "Kozhikode", state: "Kerala" },
  { name: "Kochi", state: "Kerala" },
  { name: "Alappuzha", state: "Kerala" },
  { name: "Thiruvananthapuram", state: "Kerala" },
  { name: "Kannur", state: "Kerala" },
  { name: "Chennai", state: "Tamil Nadu" },
  { name: "Puducherry", state: "Puducherry" },
  { name: "Visakhapatnam", state: "Andhra Pradesh" },
];
